const formatDate = (date: Date): string => {
    const newDate = new Date(date).toUTCString();
    const splited = newDate.split("GMT");
    return splited[0];
};

export default formatDate;
